import MasterPage, { nameColumn } from "./MasterPage";
import { ProductCategory } from "../../types";
import { PRODUCT_TYPES } from "../../constants/enums";
import { StatusBadge } from "../../components/ui/Badge";
import { formatDate } from "../../utils/format";

export default function CategoriesPage() {
    return (
        <MasterPage<ProductCategory>
            title="Product Categories"
            subtitle="Group products. Each category is registered for either hardware or software."
            endpoint="/product-category"
            singular="category"
            emptyForm={{ name: "", type: "" }}
            toForm={(r) => ({ name: r.name, type: r.type })}
            fields={[
                { name: "name", label: "Name", kind: "text", required: true, placeholder: "e.g. Printer, Retail" },
                { name: "type", label: "Registered for", kind: "segmented", required: true, options: PRODUCT_TYPES },
            ]}
            columns={[
                nameColumn<ProductCategory>(),
                { key: "type", header: "Type", render: (r) => <StatusBadge value={r.type} /> },
                { key: "created", header: "Created", hideOnMobile: true, render: (r) => <span className="text-slate-500">{formatDate(r.createdAt)}</span> },
            ]}
        />
    );
}